import { workspaceParamsSchema } from './payloads/workspace.payload';
import { z } from 'zod';
import { workspaceUserSchema } from './workspace-team.types';

export enum ApiKeyExpiryEmailSent {
    TWO_WEEKS_BEFORE = 1,
    ONE_WEEK_BEFORE = 2,
    ONE_DAY_BEFORE = 3
}

export const apiKeyParamsSchema = workspaceParamsSchema.extend({
    apiKeyUuid: z.string().uuid()
});

export const apiKeySchema = z.string().uuid();

export const apiKeyInfoSchema = workspaceUserSchema
    .pick({ email: true, firstname: true, lastname: true, picture: true })
    .extend({
        uuid: z.string().uuid(),
        userUuid: z.string().uuid(),
        creationDate: z.coerce.date(),
        expirationDate: z.coerce.date()
    });

export type ApiKeyInfo = z.infer<typeof apiKeyInfoSchema>;

export type ApiKeyAuth = {
    uuid: string;
    hash: string;
    expires: Date;
};
